import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  propertiesTitleContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 16,

    marginBottom: 33,
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      marginBottom: 6,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 16
    }
  },

  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
    borderBottom: `1px solid ${theme.app.colors.border.light}`,
    paddingBottom: 16,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      borderBottom: 'none',
      paddingBottom: 0
    }
  },

  propertiesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight,
    display: 'flex',
    alignItems: 'center',
    margin: 0,

    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none'
    }
  },

  breadcrumbSeparator: {
    margin: '0 8px',
    color: theme.palette.primary.main
  },

  breadcrumbLink: {
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: theme.app.typography.subTitle.fontWeight,
    fontSize: theme.app.typography.subTitle.fontSize,

    '&:hover': {
      textDecoration: 'underline'
    }
  },

  titleActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
      gap: 8
    }
  }
}))
